<h2 mat-dialog-title>{{"scheduled_jobs.confirmation-dialog" | translate}}</h2>
<mat-dialog-actions class="mat-card-action" align="center">
  <button mat-button mat-raised-button mat-dialog-close>{{"scheduled_jobs.confirmation-dialog_no" | translate}}</button>
  <button
    mat-button
    mat-raised-button
    color="primary"
    (click)="onClickYes()"
    mat-dialog-close
  >
  {{"scheduled_jobs.confirmation-dialog_yes" | translate}}
  </button>
</mat-dialog-actions>
